import { IAbcComponent } from '../abcComponent.model';

export interface ICard extends IAbcComponent {
  image?: string;
  displayText?: string;
  secondaryDisplayText?: string;
  thirdDisplayText?: string;
  fourthDisplayText?: string;
  description?: string;
  shortHand?: string;
  searchInput?: string;
  template?: number;
  icon: string;
  colorBar?: string;
  leftIconPath?: string;
  primaryActionName?: string;
  secondaryActionName?: string;
  thirdActionName?: string;
  fourthActionName?: string;
  rightIconSize?: number;
  leftIconSize?: number;
  leftIconPosition?: number;
  rightIsImg?: boolean;
  leftIsImg?: boolean;
  rightIconPath?: string;
  defaultImg?: string;
  headerDescription?: boolean;
  disabledTooltip?: boolean;
  buttons?: DocActionButton[];

  setCardStyle(style?: CardStyle);
  setCustomDataAttributes(data?: Object);
}

export class CardStyle {
  height: string | number;
  width: string | number;
}

export class DocActionButton {
  id: string;
  icon: string;
  visible: boolean;
  click: Function;
}

export enum Size {
  Small,
  Medium,
  Large,
}
export enum PositionIcon {
  Top,
  Middle,
  Bottom,
}
